/**
 * Rule to check if the field is truthy
 * 
 * Usage: confirmed
 * 
 */
export default {
    name     : 'checked',
    validate : (value, data, parameters) => !!value,
    message  : (field, data, parameters) => `The field ${field} must be checked`
}